import React from 'react';
import { Button } from './ui/button';
import { ArrowRight, ArrowDown } from 'lucide-react';

export const Hero = () => {
  const scrollToContact = () => {
    document.getElementById('contacto')?.scrollIntoView({ behavior: 'smooth' });
  };

  const scrollToProjects = () => {
    document.getElementById('proyectos')?.scrollIntoView({ behavior: 'smooth' });
  };

  const scrollToServices = () => {
    document.getElementById('servicios')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="inicio" className="relative min-h-screen flex flex-col justify-center pt-32 pb-20 bg-background overflow-hidden">
      {/* Subtle decorative elements */}
      <div className="absolute top-1/4 right-0 w-[500px] h-[500px] rounded-full bg-accent/5 blur-3xl pointer-events-none" />
      <div className="absolute bottom-0 left-0 w-[400px] h-[400px] rounded-full bg-foreground/3 blur-3xl pointer-events-none" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        <div className="max-w-4xl mx-auto text-center">
          {/* Trust indicator */}
          <div className="inline-flex items-center gap-2 bg-foreground/5 border border-foreground/10 rounded-full px-5 py-2 mb-8 animate-fade-in">
            <span className="w-2 h-2 bg-accent rounded-full animate-pulse" />
            <span className="text-sm font-medium text-muted-foreground tracking-wide">
              Mas de 500 empresas ya confian en nosotros
            </span>
          </div>

          {/* Main headline - Serif display */}
          <h1 className="font-display text-5xl sm:text-6xl lg:text-8xl font-bold text-foreground leading-[1.05] tracking-tight mb-8 text-balance animate-fade-in-up">
            Tecnologia que transforma{' '}
            <span className="italic text-accent">resultados</span>
          </h1>

          {/* Subheadline with clear value proposition */}
          <p className="text-lg sm:text-xl text-muted-foreground leading-relaxed max-w-2xl mx-auto mb-12 animate-fade-in-up stagger-2">
            Automatizamos tus procesos de negocio con inteligencia artificial 
            para que ahorres hasta 10 horas por semana y aumentes tus ventas un 40%.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-16 animate-fade-in-up stagger-3">
            <Button
              size="lg"
              onClick={scrollToContact}
              className="bg-foreground text-background hover:bg-foreground/90 rounded-full px-10 py-6 text-base font-medium tracking-wide transition-all duration-300 group"
            >
              Solicitar Diagnostico Gratis
              <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform duration-300" />
            </Button>
            <Button
              variant="outline"
              size="lg"
              onClick={scrollToProjects}
              className="border-foreground/20 text-foreground hover:bg-foreground/5 rounded-full px-10 py-6 text-base font-medium tracking-wide transition-all duration-300"
            >
              Ver Proyectos
            </Button>
          </div>

          {/* Stats row */}
          <div className="grid grid-cols-3 gap-8 max-w-xl mx-auto pt-12 border-t border-border animate-fade-in-up stagger-4">
            <div className="text-center">
              <div className="font-display text-3xl sm:text-4xl font-bold text-foreground">95%</div>
              <div className="text-sm text-muted-foreground mt-1">Satisfaccion</div>
            </div>
            <div className="text-center">
              <div className="font-display text-3xl sm:text-4xl font-bold text-foreground">24/7</div>
              <div className="text-sm text-muted-foreground mt-1">Soporte</div>
            </div>
            <div className="text-center">
              <div className="font-display text-3xl sm:text-4xl font-bold text-accent">+40%</div>
              <div className="text-sm text-muted-foreground mt-1">En ventas</div>
            </div>
          </div>
        </div>

        {/* Scroll indicator */}
        <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce hidden lg:block">
          <button
            onClick={scrollToServices}
            className="text-muted-foreground hover:text-foreground transition-colors duration-300"
            aria-label="Ver servicios"
          >
            <ArrowDown className="h-5 w-5" />
          </button>
        </div>
      </div>

      {/* Marquee trust bar */}
      <div className="mt-20 border-t border-b border-border py-5 overflow-hidden">
        <div className="flex animate-marquee whitespace-nowrap">
          {[...Array(2)].map((_, setIndex) => (
            <div key={setIndex} className="flex items-center gap-12 px-6">
              <span className="text-sm font-medium text-muted-foreground uppercase tracking-[0.2em]">Inteligencia Artificial</span>
              <span className="text-accent text-lg">*</span>
              <span className="text-sm font-medium text-muted-foreground uppercase tracking-[0.2em]">Machine Learning</span>
              <span className="text-accent text-lg">*</span>
              <span className="text-sm font-medium text-muted-foreground uppercase tracking-[0.2em]">Vision Computacional</span>
              <span className="text-accent text-lg">*</span>
              <span className="text-sm font-medium text-muted-foreground uppercase tracking-[0.2em]">Automatizacion</span>
              <span className="text-accent text-lg">*</span>
              <span className="text-sm font-medium text-muted-foreground uppercase tracking-[0.2em]">Analisis de Datos</span>
              <span className="text-accent text-lg">*</span>
              <span className="text-sm font-medium text-muted-foreground uppercase tracking-[0.2em]">Software a Medida</span>
              <span className="text-accent text-lg">*</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
